import React, {PropTypes} from 'react';
import { FormattedMessage } from 'react-intl';

import { colors } from 'app/globals';
import { Row, Col } from 'routes/app/components';
import { Button, Table, TableActions, Modal } from 'routes/app/components';
import { Bubble } from 'routes/app/components';

const UnitsTable = ({addUnit, editUnit, formatMessage, showUnit, removeUnit, units}) => {

    return (
        <Row>
            <Col s={12}>
                <ul className="collection with-header">
                    <li className="collection-header">
                        <h2><FormattedMessage id="visit.units.table.header" /></h2>
                        <Bubble backgroundColor={colors.primary}
                                onStart={addUnit}
                                onComplete={showUnit}
                            >
                            <Button floating><i className="material-icons">add</i></Button>
                        </Bubble>
                    </li>
                    <li style={{overflowX: 'auto'}}>
                        <Table className="with-actions" striped responsive-table>
                            <thead>
                                <tr>
                                    <th data-field="io"><FormattedMessage id="visit.units.table.io" /></th>
                                    <th data-field="ref"><FormattedMessage id="visit.units.table.ref" /></th>
                                    <th data-field="unit"><FormattedMessage id="visit.units.table.unit" /></th>
                                    <th data-field="status"><FormattedMessage id="visit.units.table.status" /></th>
                                    <th data-field="ef"><FormattedMessage id="visit.units.table.ef" /></th>
                                    <th data-field="actions" />
                                </tr>
                            </thead>
                            <tbody>
                            {!units.length && <tr>
                                <td colSpan="6"><FormattedMessage id="visit.units.table.noUnits" /></td>
                            </tr>}
                            {units.map((unit, index) =>
                                <tr key={index}>
                                    <td>{unit.inOut.value &&<FormattedMessage id={`unit.type.${unit.inOut.value.toLowerCase()}`} />}</td>
                                    <td>{unit.reference.value}</td>
                                    <td>{unit.ctNumber.value}</td>
                                    <td>{unit.status.value}</td>
                                    <td>{unit.empty.value && <FormattedMessage id={`unit.empty.${unit.empty.value}`} />}</td>
                                    <td className="table-actions" style={{width: 90}}>
                                        <Bubble backgroundColor={colors.secondary}
                                                onStart={() => editUnit(unit.trac.value)}
                                                onComplete={showUnit}>
                                            <Button className="table-actions__edit"><i
                                                className="material-icons">mode_edit</i></Button>
                                        </Bubble>
                                       <Modal
                                            header={formatMessage({id:'unit.remove.confirm.title'})}
                                            onClickAgree={() => removeUnit(unit.trac.value)}
                                            textDisagree={formatMessage({id:'unit.remove.confirm.btnCancel'})}
                                            textAgree={formatMessage({id:'unit.remove.confirm.btnOK'})}
                                            trigger={
                                                    <Button className="table-actions__remove"><i
                                                        className="material-icons">delete</i></Button>
                                                }>
                                            <p>{formatMessage({id:'unit.remove.confirm'})}</p>
                                        </Modal>

                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </li>
                </ul>
            </Col>
        </Row>
    );
};

UnitsTable.propTypes = {
    addUnit: PropTypes.func,
    editUnit: PropTypes.func,
    formatMessage: PropTypes.func,
    removeUnit: PropTypes.func,
    showUnit: PropTypes.func,
    units: PropTypes.array
};

UnitsTable.defaultProps = {
    units: []
};

export default UnitsTable;